import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar, X } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/ai-scale-hq/30min';

export const MobileBottomCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400 && !isDismissed) {
        setIsVisible(true);
      } else if (window.scrollY <= 400) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25 }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-4 bg-gradient-to-t from-[#0E0F14] via-[#0E0F14] to-transparent"
          data-testid="mobile-bottom-cta"
        >
          <div className="flex items-center gap-3">
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 bg-[#6C4DFF] hover:bg-[#8468FF] text-white font-medium py-3.5 rounded-full flex items-center justify-center gap-2 transition-colors"
              data-testid="mobile-cta-button"
            >
              <Calendar className="w-5 h-5" />
              Book a Call
            </a>
            <button
              onClick={() => {
                setIsDismissed(true);
                setIsVisible(false);
              }}
              className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center"
              data-testid="mobile-cta-dismiss"
              aria-label="Dismiss"
            >
              <X className="w-5 h-5 text-white/60" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
